<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Planes de usuarios
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right">
            <input
              type="text"
              placeholder="Buscar"
              class="input_solid"
              v-model="options_table.search"
            >
            <img
              src="@/assets/img/icons/search-icon.svg"
              class="button_search"
            >
          </v-flex>
          <div
            class="buttom_reload"
            @click="getUsersCategories()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-data-table
        v-model="usersCategories"
        :headers="options_table.headers_table"
        :items="usersCategories"
        :search="options_table.search"
        :pagination.sync="options_table.pagination"
        select-all
      >
        <template slot="headers" slot-scope="props">
          <!-- <tr>
            <th v-for="header in options_table.headers_table" :key="header.text">
              <div v-if="options_table.filters.hasOwnProperty(header.value)">
                <v-select
                  v-if="columnValueList(header.value)[0] != null"
                  flat
                  hide-details
                  small
                  multiple
                  clearable
                  :items="columnValueList(header.value)"
                  v-model="options_table.filters[header.value]"
                  :placeholder="header.text"
                >
                </v-select>
              </div>
            </th>
          </tr> -->
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                options_table.pagination.descending ? 'desc' : 'asc',
                header.value === options_table.pagination.sortBy ? 'active' : ''
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
            <td
              class="text-xs-center"
              v-html="locationsNames(props.item.access_doors)"
            ></td>
            <td class="text-xs-center">
              <a
                href=""
                @click.prevent="
                  $router.push({
                    name: 'user_edit_plan',
                    query: { id: props.item.id }
                  })
                "
              >
                Editar
              </a>
            </td>
            <td class="text-xs-center">
              <a @click.prevent="showConfirmModal(props.item.id)">
                Eliminar
              </a>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <section
      v-if="show_confirm_modal"
      class="access_devices__modal">
      <section class="access_devices__modal--container" style="width: 40%;">
        <p class="access_devices__modal--text" style="text-align: justify;">
          <b>AVISO:</b> Al eliminar el plan de usuario se <b>denegará</b> el acceso de los usuarios a las locaciones incluidas en este plan y serán <b>desvinculados</b> de las locaciones a las que esten relacionados.
        </p>
        <br>
        <p class="access_devices__modal--text">
          ¿Está seguro de eliminar el plan de usuario?
        </p>
        <div class="access_devices__modal--buttons" style="margin-top: 1rem;">
          <div
            class="access_devices__modal--button"
            @click="closeConfirmModal">
            Cancelar
          </div>
          <div
            class="access_devices__modal--button active"
            @click="deleteUserCategory">
            Si
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      available_locations: [],
      search: "",
      options_table: {
        pagination: {
          sortBy: "name",
          rowsPerPage: 10
        },
        headers_table: [
          {
            text: "Nombre",
            align: "center",
            value: "name"
          },
          {
            text: "Descripción",
            align: "center",
            value: "description"
          },
          {
            text: "Acceso a las sedes",
            align: "center",
            value: "access_doors"
          },
          {
            text: "Actualizar",
            align: "center",
            value: "update"
          },
          {
            text: "Eliminar",
            align: "center",
            value: "delete"
          }
        ],
        filters: {
          access_state: []
        }
      },
      usersCategories: [],
      show_confirm_modal: false,
      user_category_to_delete: null,
    };
  },
  mounted() {
    this.getUsersCategories();
    this.getLocations();
  },
  methods: {
    locationsNames(arr) {
      let locations = this.available_locations.filter(loc => {
        return arr.includes(loc.location_id);
      });
      let locationStr = "";
      locations.map(loc => {
        locationStr += locationStr == "" ? loc.name : `, ${loc.name}`;
      });
      locationStr =
        locationStr != ""
          ? locationStr
          : "<b>EL PLAN NO POSEE ACCESO A NINGUNA SEDE</b>";
      return locationStr;
    },
    columnValueList(val) {
      return this.usersCategories.map(d => d[val]);
    },
    getUsersCategories() {
      try {
        const params = { company_id: this.getCompany().id };
        this.$http
          .get("user_categories/index", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params
          })
          .then(
            function(response) {
              this.usersCategories = response.body;
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            },
            function(response) {
              if (typeof response.body.errors[0].details != "object") {
                alert(response.body.errors[0].details);
              } else {
                let message = [];
                for (var key in response.body.errors[0].details) {
                  message.push(response.body.errors[0].details[key]);
                }
                alert(message);
              }
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
            }
          );
      } catch (e) {
        alert(e.message);
        if (response.body.meta != undefined && response.body.meta != null) {
          if (
            response.body.meta.authentication_token != undefined &&
            response.body.meta.authentication_token != null
          ) {
            this.checkToken(response.body.meta.authentication_token);
          }
        }
      }
    },
    deleteUserCategory(){
      this.$http
      .delete("user_categories/destroy", {
        headers: {
          "X-Device-ID": this.getDeviceId(),
          Authorization: "Bearer " + this.getUserToken()
        },
        params: {
          id: this.user_category_to_delete,
          company_id: this.getCompany().id
        }
      })
      .then(function(response) {
        this.updateAlertMessage("Plan de usuario eliminado satisfactoriamente");
        this.updateIsInAlert(true);
        this.getUsersCategories();
      })
      .catch(function(response) {
        this.updateAlertMessage(response.body.errors[0].title);
        this.updateIsInAlert(true);
      });

      this.closeConfirmModal();
    },
    getLocations() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .post(
            "locations/company",
            { data: this.encrypt(data).toString() },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(function(response) {
            this.sortAvailableLocations(response.body);
          });
      } catch (e) {
        alert(e);
      }
    },
    sortAvailableLocations(dataResponse) {
      this.available_locations = [];
      for (var i = 0; i < dataResponse.data.length; i++) {
        if (dataResponse.data[i].attributes.published == true) {
          this.available_locations.push({
            location_id: parseInt(dataResponse.data[i].id),
            name: dataResponse.data[i].attributes.name
          });
        }
      }
    },
    showConfirmModal(userCategoryId){
      this.user_category_to_delete = userCategoryId
      this.show_confirm_modal = true
    },
    closeConfirmModal(){
      this.user_category_to_delete = null
      this.show_confirm_modal = false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/access/ListUserCategories.vue